// REAL pop-up events pending launch (Josh's seed list, 2026-08-05 →).
//
// Why a file and not DB rows: there is no dev/prod Supabase split — a real row
// would render on the LIVE film page and could fire watchlist alert emails
// before Josh's ship word. On dev hosts these render exactly like live data
// (tagged "pending"); at ship, scripts/seed-popups writes them to the DB via
// the matcher (canonical records + posters) and this list is emptied.
//
// tmdbId is pre-verified by hand; movieId is filled where a DB record already
// exists (none yet — records get minted at ship).
// SHIPPED 2026-08-12: the launch seeds were written to the DB as real popup-
// rows by the seed script; this list is now EMPTY so dev hosts don't render
// duplicates beside the live rows. Future pre-ship batches can stage here again.
export const SEED_EVENTS = [];
